import React, { useState, useEffect, useRef } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import Card from '../../../components/Card'
import { getApiCall,postApiCall,deleteApiCallWithHeader} from '../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import RenderDeleteModal from '../../../components/partials/components/delete-modal';
import ToastNotification from '../../../components/Toast';
import { ROUTES, USER_STATUS_LABEL, MODULE_ACL, USER_ROLES } from '../../../utilities/constant';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { EditIcon, DeleteIcon } from '../../../components/setting/elements';
import { API_MODULE_LIST, API_MODULE_DELETE } from '../../../service/url';
import Loader  from '../../../components/partials/components/loader';
import { Checkbox } from 'primereact/checkbox';
import "../../../assets/custom/css/custom.css";
//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';
//core
import 'primereact/resources/primereact.min.css';
import { useAuth, errorCheck } from '../auth/auth-utils';
import { useNavigate } from "react-router-dom";
import exportData from '../../../utilities/export';
import { getUser } from "../../../utilities/setting";
import { toast } from "react-toastify";



export default function ModuleList() {
   const { checkAuth } = useAuth();
   const navigate = useNavigate();
   const [module,setModule] = useState([]);
   const [filters, setFilters] = useState({
      module_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
      status: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
   const [enableDeleteModal, setEnableDeleteModal] = useState(false);
   const [confirmDelete, setConfirmDelete] = useState(false);
   const [deleteModuleId, setDeleteModuleId] = useState(undefined);
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [loading, setLoading] = useState(false);
   const [selectedModule, setSelectedModule] = useState([]);
   const [isMultiDelete, setIsMultiDelete] = useState(false);
   const [buttonDisable, setButtonDisable] = useState(false);

   const [searchValue, setSearchValue] = useState(null);
   const [originalDataList, setOriginalDataList] = useState([]);
   const [loggedInUserACL, setLoggedInUserACL] = useState({})
   const [isSuperAdmin, setIsSuperadmin] = useState(false)

   const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: "module-list",
         data: module,
         columns: [
            {
               header: "Module Name",
               accessor: "module_name"
            },
            {
               header: "Status",
               accessor: (row) =>
                  row.status || "-"
            },
            {
               header: "Created Date",
               accessor: (row) =>
                  new Date(row.created_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};
  
    const handleCheckboxToggle = (moduleId) => {
      const isSelected = selectedModule.includes(moduleId);
      setSelectedModule(isSelected
          ? selectedModule.filter(id => id !== moduleId)
          : [...selectedModule, moduleId]);
    };
  
    const handleMultiDelete = () => {
          setIsMultiDelete(true);
          setEnableDeleteModal(true);
    };

   // useEffect(() => {

   //    if (toastProps) {
   //       setShowToast(true);
   //    }

   // }, [toastProps]);

   useEffect(() => {
      setLoading(true);
      const user = getUser();
         if (user.role === USER_ROLES.SUPERADMIN) {
            setIsSuperadmin(true);
         }
         if (user?.acl_settings) {
            setLoggedInUserACL(JSON.parse(user.acl_settings.module_operations));
         }
      getApiCall(API_MODULE_LIST)
         .then(onModuleListSuccess)
         .catch(onError)
         .finally(() => setLoading(false));

   }, []);

   const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});
   
     useEffect(() => {
      const user = getUser();
         if (user) {
           if (user?.acl_settings) {    
             setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
           }
         }
     }, []);


   function onModuleListSuccess(resp) {
      const updatedList = resp.map((val, idx) => {
         val['key'] = idx + 1;
         // val['actions'] = RenderActionComponent(val.id);
         val['created_at'] = new Date(val['created_at']).toGMTString();
         return val;
      });
      setModule(updatedList);
      setOriginalDataList(updatedList);
   }

   useEffect(() => {
      if(searchValue){
         setModule(
            module.filter((data) => data.module_name.toLowerCase().includes(searchValue.trim().toLowerCase()))
         );
      }
      else {
         setModule(originalDataList); // Reset to the original list if no module name is selected
      }
   }, [searchValue, module]);

   function handleDeleteModule(id) {
      checkAuth(setToastProps, setShowToast);
      setIsMultiDelete(false);
      setEnableDeleteModal(true);
      setDeleteModuleId(id);
   }

   const handleSelectAll = () => {
      if (selectedModule.length === module.length) {
          setSelectedModule([]);
      } else {
          const allModuleIds = module.map(allModuleIds => allModuleIds.id);
          setSelectedModule(allModuleIds);
      }
    };

   useEffect( () => {
      if (confirmDelete) {
          if (isMultiDelete) {
              postApiCall(API_MODULE_DELETE, { moduleIds: selectedModule })
                  .then(onDeleteSuccess)
                  .catch(onDeleteFail);
          } else {
              postApiCall(API_MODULE_DELETE, { moduleIds: [deleteModuleId] })
                  .then(onDeleteSuccess)
                  .catch(onDeleteFail);
          }
      }
      }, [confirmDelete]);



   function onDeleteSuccess(resp) {
      // setToastProps({ type: 'success', message: 'Module deleted successfully' });
          toast.success("Module deleted successfully");
      let updatedList;
      if (isMultiDelete) {
        updatedList = module.filter(val => !selectedModule.includes(val.id)).map((val, key) => {
            val['key'] = key + 1;
            return val;
        });
        setSelectedModule([]);

        setLoading(true);
        getApiCall(API_MODULE_LIST)
           .then(onModuleListSuccess)
           .catch(onError)
           .finally(() => setLoading(false));
    } else {
        updatedList = module.filter(val => val.id != deleteModuleId).map((val, key) => {
         val['key'] = key + 1;
         return val;
      });

      setLoading(true);
      getApiCall(API_MODULE_LIST)
         .then(onModuleListSuccess)
         .catch(onError)
         .finally(() => setLoading(false));
    }
      setModule(updatedList);
      setEnableDeleteModal(false);
      setDeleteModuleId(undefined);
      setConfirmDelete(false); 
   }

   function onDeleteFail(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
          toast.error(`Unable to delete module: ${err}`);
      }
      setConfirmDelete(false); 
   }

   const RenderActionComponent = ({id}) => {
      const moduleEditRoute = ROUTES.MODULE.EDIT.replace(':id', id);
      return (
         <div className="flex align-items-center list-user-action">
            {(isSuperAdmin || loggedInUserACL[MODULE_ACL.MODULE_LIST]?.edit) && (
               <EditIcon linkTo={`/${moduleEditRoute}`} />
            )}
            {' '}
            {(isSuperAdmin || loggedInUserACL?.[MODULE_ACL.MODULE_LIST]?.delete) &&
            selectedModule.length === 0 && (
                <DeleteIcon handleCallback={() => handleDeleteModule(id)} />
            )}
            {' '}
         </div>
      );

   }

   const dropdownItemTemplate = (option) => {
      return <span>{option}</span>;
   }

   const statusFilterTemplate = (options) => {
      return <Dropdown value={options.value} options={USER_STATUS_LABEL} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dropdownItemTemplate} placeholder="Select One" className="p-column-filter" showClear />;
   }

  

   function onError(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
        console.log(err)
      }
   }

   const handleCreateButtonClick = () => {
      navigate(`/${ROUTES.MODULE.CREATE}`);
   } 

   const rowClassName = (data) => {
      return {
          'highlighted-row': selectedModule.includes(data.id)
        };
    }

    const actionBodyTemplate = (rowData) => {
      return <RenderActionComponent id={rowData.id} />;
    };

   if (loading) {
      return <Loader />
   }

   return (
      <>
         <div>
            <Row>
               <Col sm="12">
                  <Card>
                     <Card.Header className="d-block justify-content-between">
                        <div className="header-title">
                           <h4 className="card-title">Module List</h4>
                        </div>
                        <button className="btn btn-primary ml-auto" onClick={handleCreateButtonClick}>Create Module</button>
                     </Card.Header>
                     <Card.Body className="px-0">
                     <div style={{display: "flex", alignItems: "flex-start", justifyContent: "flex-start"}}>
                         {((isSuperAdmin || loggedInUserACL?.[MODULE_ACL.MODULE_LIST]?.delete)) && (
                           <Button 
                              label="Delete Selected" 
                              onClick={handleMultiDelete} 
                              className="p-button-danger p-button-sm" 
                              style={{ marginBottom: '10px', marginLeft: '10px' }} 
                              disabled={selectedModule.length === 0} 
                           />
                         )}
                        {module.length > 0 && <Button 
                           label="Export Data"
                           icon="pi pi-file-export"
                           onClick={handleExport} 
                           className="p-button-active p-button-sm" 
                           style={{ marginBottom: '10px', marginLeft: '10px' }} 
                           disabled={buttonDisable} 
                        >
                           &nbsp;
                           {buttonDisable && (
                              <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                           )}
                        </Button>}
                        
                        <Form.Group style={{height: "45px"}}>
                           <Form.Control
                              style={{height: "50px", marginLeft: "10px", border: "1px solid #ced4da", fontSize: "15px", height: "45px"}}
                              placeholder = 'Search by Name...'
                              type="text"
                              maxLength={100}
                              value={searchValue} 
                              onChange={(e) => setSearchValue(e.target.value)}
                              required
                           />
                        </Form.Group>
                        </div>
                        <div className="scroll-container">
                           <div className="table-responsive border-bottom my-3">
                              <DataTable value={module} tableStyle={{ minWidth: '50rem' }} filters={filters} paginator rows={8} rowClassName={rowClassName}>
                                 <Column 
                                    header={<Checkbox 
                                    checked={selectedModule.length === module.length && module.length > 0} 
                                    onChange={handleSelectAll} 
                                    />} 
                                    headerStyle={{ width: '3rem' }} 
                                    body={(rowData) => (
                                    <Checkbox 
                                       checked={selectedModule.includes(rowData.id)} 
                                       onChange={() => handleCheckboxToggle(rowData.id)} 
                                    />
                                    )} 
                                 />
                                 <Column field="module_name" filterField="module_name" header="Module Name" filter filterPlaceholder="Search by Module name" ></Column>
                                 <Column field="status" header="Status" filterElement={statusFilterTemplate} filter></Column>
                                 <Column field="created_at" header="Created Date" body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                                 {/* <Column header="Action" body={actionBodyTemplate} /> */}
                              </DataTable>
                           </div>
                        </div>
                     </Card.Body>
                  </Card>
               </Col>
            </Row>
         </div>

         <RenderDeleteModal 
            show={enableDeleteModal} 
            setShow={setEnableDeleteModal} 
            setConfirmDelete={setConfirmDelete} 
            isMultiDelete={isMultiDelete} 
            clearSelectedData={() => setSelectedModule([])}
         />

         {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

      </>
   )

}